/*
  Kremi vitrin (10-12, Zeynep: "Isamaya'daki popup animasyonu harika") — bülten penceresinin
  açılış/kapanış hareketi. Tema (Prestige PopIn) yalnız 0,4 sn opaklık veriyordu; burada
  Isamaya'nın (Concept teması newsletter-modal) üç katmanlı hareketi kurulur:

    1. Arka plan karartması yumuşakça gelir (0,8 sn).
    2. Kutu %80'den büyüyerek belirir (0,6 sn, cubic-bezier(.7,0,.2,1)).
    3. Kutu oturunca görsel paneli SIFIR genişlikten yana doğru açılır, kutu onunla genişler;
       görsel içeride hafifçe yerine oturur, form öğeleri sırayla gelir.
  Mobilde aynı sıra dikey eksende: önce metin kutusu, sonra görsel kutunun arkasından YUKARI çıkar.

  Tema dosyasına dokunulmaz: tanımlı <newsletter-popup> sınıfının enter/leave animasyon
  yöntemleri ezilir (sözleşme: dönen nesnede .finished + .finish()). Hareket azaltma
  tercihinde ve "immediate" açılışta (form gönderimi sonrası) temanın davranışı aynen kalır.
  `transform` temada !important olduğu için hareket bağımsız `scale`/`translate` ile yapılır.

  10-16 (mobil denetim T3/E1): pencerenin NE ZAMAN açılacağı (2. sayfa ya da 25 sn, 14 gün kapalı kalma)
  ve modal erişilebilirliği (odak tuzağı, Esc, aria-modal, odağın geri dönmesi) de burada — aşağıya bak.
*/
(() => {
  // Yumuşak duruş (Zeynep 10-12: "çok daha yumuşak"): expo-out — hızlı başlar, uzun ve sakin yavaşlar.
  const EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';
  const EASE_SOFT = 'cubic-bezier(0.22, 1, 0.36, 1)';
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesktop = () => window.matchMedia('(min-width: 700px)').matches;

  const scrimFor = (popup) => {
    let scrim = popup.__kremiScrim;
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'kremi-popup-scrim';
      scrim.addEventListener('click', () => popup.removeAttribute('open'));
      popup.__kremiScrim = scrim;
    }
    if (!scrim.isConnected) document.body.append(scrim);
    return scrim;
  };

  const staggerForm = (popup, startDelay) => {
    const items = popup.querySelectorAll('.newsletter-popup__form-section .v-stack.gap-8 > *');
    items.forEach((item, i) => {
      item.animate(
        { opacity: [0, 1], translate: ['0 10px', '0 0'] },
        { duration: 900, delay: startDelay + i * 70, easing: EASE_SOFT, fill: 'backwards' }
      );
    });
  };

  function enter() {
    if (reduceMotion() || this.getAttribute('open') === 'immediate') {
      return this.animate({ opacity: [0, 1] }, { duration: 250 });
    }

    const scrim = scrimFor(this);
    scrim.animate({ opacity: [0, 1] }, { duration: 1000, easing: 'ease-out', fill: 'forwards' });

    const image = this.querySelector('.newsletter-popup__image');
    const imageEl = image && image.querySelector('img');

    if (!image) {
      const box = this.animate({ opacity: [0, 1], scale: [0.96, 1] }, { duration: 800, easing: EASE_SOFT });
      staggerForm(this, 300);
      return box;
    }

    // Isamaya sırası: (1) yalnız METİN kutusu açılır, (2) görsel metnin ARKASINDAN çıkar — masaüstünde
    // sola (görsel solda), mobilde YUKARI (görsel üstte; 10-13, Zeynep: "mobilde metin kutusunun altından
    // yukarı doğru çıkmalı"; eskiden yukarıdan aşağı perde gibi açılıyordu). Yerleşim baştan son hâlinde;
    // metin dışındaki alan clip-path ile gizlenir, görsel metin kutusunun altına kaydırılmış başlar.
    // Metin sütunu, görsel altından geçerken görünmesin diye geçici zemin rengi + üst katman alır.
    const desktop = isDesktop();
    const form = this.querySelector('.newsletter-popup__form-section');
    const content = this.querySelector('.newsletter-popup__content');
    const popupRect = this.getBoundingClientRect();
    const imageRect = image.getBoundingClientRect();
    const contentCs = getComputedStyle(content);
    const cs = getComputedStyle(this);
    const px = (v) => parseFloat(v) || 0;

    let cut, clipFrom, slideFrom, origin, cover;
    if (desktop) {
      cut = imageRect.right - popupRect.left;
      const gap = px(contentCs.columnGap);
      clipFrom = `inset(0 0 0 ${cut}px)`;
      slideFrom = `${cut}px 0`;
      origin = `${cut + (popupRect.width - cut) / 2}px 50%`;
      // Görsel kutunun üst/alt iç boşluğuna da taşıyor (negatif margin) → örtü tam yükseklikte olmalı.
      const padTop = px(cs.paddingTop), padBottom = px(cs.paddingBottom);
      cover = {
        marginInlineStart: `${-gap}px`, paddingInlineStart: `${gap}px`,
        marginBlock: `${-padTop}px ${-padBottom}px`, paddingBlock: `${padTop}px ${padBottom}px`,
      };
    } else {
      cut = imageRect.bottom - popupRect.top;
      const gap = px(contentCs.rowGap);
      clipFrom = `inset(${cut}px 0 0 0)`;
      slideFrom = `0 ${cut}px`;
      origin = `50% ${cut + (popupRect.height - cut) / 2}px`;
      const padLeft = px(cs.paddingLeft), padRight = px(cs.paddingRight);
      cover = {
        marginBlockStart: `${-gap}px`, paddingBlockStart: `${gap}px`,
        marginInline: `${-padLeft}px ${-padRight}px`, paddingInline: `${padLeft}px ${padRight}px`,
      };
    }

    Object.assign(form.style, { position: 'relative', zIndex: '1', background: 'rgb(var(--background))', ...cover });
    image.style.position = 'relative';
    image.style.zIndex = '0';
    image.style.willChange = 'translate';
    this.style.transformOrigin = origin;
    this.style.willChange = 'opacity, scale, clip-path';

    const box = this.animate(
      { opacity: [0, 1], scale: [0.96, 1], translate: ['0 12px', '0 0'] },
      { duration: 900, easing: EASE_SOFT }
    );
    // Görsel kutu tam oturmadan, son yavaşlama evresinde yola çıkar — iki hareket birbirine akar.
    const reveal = { duration: 1400, delay: 550, easing: EASE, fill: 'backwards' };
    this.animate({ clipPath: [clipFrom, 'inset(0px 0px 0px 0px)'] }, reveal);
    const slide = image.animate({ translate: [slideFrom, '0 0'] }, reveal);

    slide.finished.finally(() => {
      ['position', 'zIndex', 'background', ...Object.keys(cover)].forEach((k) => (form.style[k] = ''));
      image.style.position = '';
      image.style.zIndex = '';
      image.style.willChange = '';
      this.style.transformOrigin = '';
      this.style.willChange = '';
    });

    staggerForm(this, 200);
    return box;
  }

  function leave() {
    const scrim = this.__kremiScrim;
    if (scrim && scrim.isConnected) {
      scrim.animate({ opacity: [1, 0] }, { duration: 500, easing: 'ease-out', fill: 'forwards' })
        .finished.then(() => scrim.remove(), () => scrim.remove());
    }
    if (reduceMotion()) {
      return this.animate({ opacity: [1, 0] }, { duration: 200 });
    }
    return this.animate(
      { opacity: [1, 0], scale: [1, 0.98] },
      { duration: 400, easing: EASE_SOFT }
    );
  }

  // Çerez bandı açıkken ya da seçimden sonraki bekleme süresinde (snippets/kremi-cookie-consent) pencere
  // CSS ile gizleniyor; tema yine de 4. saniyede açıyordu → karartma boş ekranı kararttı, pencere
  // bekleme bitince animasyonsuz belirdi (Zeynep 10-12: "çok geç açılıp uzun süre karanlık kalıyor").
  // Artık açılış bu süre bitene kadar ERTELENİR; sonra hareketiyle birlikte açılır.
  const consentBlocking = () => {
    const c = document.documentElement.classList;
    return c.contains('kremi-consent-open') || c.contains('kremi-consent-cooldown');
  };

  const whenConsentClear = (fn) => {
    if (!consentBlocking()) return fn();
    const mo = new MutationObserver(() => {
      if (consentBlocking()) return;
      mo.disconnect();
      fn();
    });
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  };

  /*
    Ne zaman açılır (10-16, Zeynep: "bunları düzenle hemen" — mobil denetim T3/E1):
    - İLK sayfada hemen açılmaz: ziyaretçinin en az 2. sayfası olmalı YA DA ilk sayfada 25 sn geçmiş olmalı.
      Sayfa sayacı (kremi:pv) sections/newsletter-popup.liquid'de, pencerenin basılmadığı sayfalarda da artar.
    - Kapatılınca 14 gün boyunca HİÇBİR sekmede açılmaz (kremi:popup-dismissed-at). Temanın kendi kaydı
      (theme:popup-appeared) sessionStorage'da, sekmeye özel — yeni sekmede pencere yeniden açılıyordu.
      O kayıt olduğu gibi kalır (aynı sekmede ikinci kez açılmaz); bu kayıt onun üstüne eklenir.
    - Abone olunca hiç açılmaz: temanın kendi kaydı (localStorage theme:popup-filled) zaten bunu yapıyor.
    Depo: localStorage; erişilemezse sessionStorage (en azından o sekmede çalışır). Sayaç aynı sırayla seçer.
  */
  const K_PV = 'kremi:pv';
  const K_DISMISSED = 'kremi:popup-dismissed-at';
  const DISMISS_MS = 14 * 24 * 60 * 60 * 1000;
  const FIRST_PAGE_WAIT_MS = 25000;
  const store = (() => {
    for (const name of ['localStorage', 'sessionStorage']) {
      try {
        const s = window[name];
        s.setItem('kremi:probe', '1');
        s.removeItem('kremi:probe');
        return s;
      } catch (e) { /* sonraki depoyu dene */ }
    }
    return null;
  })();
  const read = (k) => { try { return store ? store.getItem(k) : null; } catch (e) { return null; } };
  const write = (k, v) => { try { if (store) store.setItem(k, v); } catch (e) { /* sessiz */ } };
  const dismissedRecently = () => {
    const at = parseInt(read(K_DISMISSED) || '', 10);
    const age = Date.now() - at;
    return at > 0 && age >= 0 && age < DISMISS_MS;
  };
  const pageViews = () => parseInt(read(K_PV) || '0', 10) || 0;
  const designMode = () => !!(window.Shopify && window.Shopify.designMode);
  const isPopup = (el) => !!el && el.localName === 'newsletter-popup';

  /*
    Erişilebilirlik (E1): tema PopIn'i odak tuzağını kapatıyordu (shouldTrapFocus false) → odak pencereye
    gitmiyor, Tab arkadaki sayfada dolaşıyor, Esc kapatmıyordu. Bülten penceresi karartmalı tam modal
    olduğu için tuzak açılır: temanın DialogElement'i FocusTrap'i kurar (Tab pencere içinde döner, Esc
    kapatır, kapanınca odak önceki öğeye döner). Dokunmatikte tema ilk odağı vermiyor (initialFocus
    false) → açılınca odak kapat düğmesine taşınır (klavye açılmasın diye e-posta alanına değil).
  */
  const returnFocus = new WeakMap();
  document.addEventListener('dialog:before-show', (e) => {
    if (!isPopup(e.target)) return;
    e.target.setAttribute('aria-modal', 'true');
    returnFocus.set(e.target, document.activeElement);
  }, true);
  document.addEventListener('dialog:after-show', (e) => {
    const popup = e.target;
    if (!isPopup(popup) || !popup.open || popup.contains(document.activeElement)) return;
    const target = popup.querySelector('.pop-in__close-button') || popup.querySelector('input:not([type="hidden"])');
    if (target) target.focus({ preventScroll: true });
  }, true);
  document.addEventListener('dialog:before-hide', (e) => {
    if (!isPopup(e.target) || designMode()) return;
    write(K_DISMISSED, String(Date.now()));
  }, true);
  document.addEventListener('dialog:after-hide', (e) => {
    const popup = e.target;
    if (!isPopup(popup)) return;
    popup.removeAttribute('aria-modal');
    const prev = returnFocus.get(popup);
    returnFocus.delete(popup);
    const active = document.activeElement;
    if (prev && prev !== document.body && prev.isConnected && (!active || active === document.body || popup.contains(active))) {
      try { prev.focus({ preventScroll: true }); } catch (err) { /* odaklanamayan öğe */ }
    }
  }, true);
  // Yedek: tuzak giriş hareketi bitince etkinleşiyor — o arada basılan Esc de kapatsın.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    const popup = document.querySelector('newsletter-popup[open]');
    if (popup) popup.hide();
  });

  customElements.whenDefined('newsletter-popup').then(() => {
    const Popup = customElements.get('newsletter-popup');
    Popup.prototype.createEnterAnimationControls = enter;
    Popup.prototype.createLeaveAnimationControls = leave;
    Object.defineProperty(Popup.prototype, 'shouldTrapFocus', { configurable: true, get: () => true });

    const originalShow = Popup.prototype.show;
    Popup.prototype.show = function (...args) {
      // Tema editörü (bölüm seçimi) pencereyi hemen göstermeli; kurallar yalnız vitrin içindir.
      if (designMode()) return originalShow.apply(this, args);
      if (dismissedRecently()) return undefined;
      const proceed = () => {
        if (this.open || dismissedRecently()) return;
        whenConsentClear(() => originalShow.apply(this, args));
      };
      const wait = pageViews() >= 2 ? 0 : FIRST_PAGE_WAIT_MS - performance.now();
      if (wait > 0) setTimeout(proceed, wait);
      else proceed();
      return undefined;
    };
  });
})();
